import React from 'react';
import { FormattedMessage } from 'react-intl';

import { CUSTOM_TOASTER } from '..';

export function simpleSignError(status, response) {
  // eslint-disable-next-line no-console
  console.log(status, response);
  let context;
  if (response && response.developerMessage === 'Failed to convert file to PDF.') {
    context = 'CONVERTING_TO_PDF';
  } else {
    context = 'GETTING_SIGN_URL';
  }
  const customComponent = (
    <span>
      <FormattedMessage id="THERE_WAS_A_PROBLEM" />
      <span>&nbsp;</span>
      <FormattedMessage id={context} />
      <span>.&nbsp;</span>
      <FormattedMessage id="PLEASE_TRY_AGAIN_LATER" />
    </span>
  );
  return {
    type: CUSTOM_TOASTER,
    severity: 'danger',
    timeout: null,
    exclusions: false,
    customComponent,
  };
}



// WEBPACK FOOTER //
// ./src/modules/helpers/simpleSignError.js